import axios from 'axios';
import { baseUrl, apiKey } from '../config';

class BangkeoService {
  constructor() {
  }
  fetchLeaguesMatchesFull = async (queryObject) => {

    // Example param query: 
    // ?search=abc
    // &filter=type:1
    // &fields=id,matchTime,homeName,awayName,homeScore
    // &sort=name:asc
    // &page=1
    // &limit=10
    // &include=homeTeam,awayTeam
    // &searchInclude=abc
    // &filterInclude=date:2024-09-02
    // &fieldsInclude=id,matchTime,homeName,awayName,homeScore,awayScore,homeHalfScore,awayHalfScore,explain,status
    try {
      const response = await axios.get(`${baseUrl}/leagues/league-in-bangkeo`, {
        headers: {
          ['x-signature']: apiKey,
        },
        params: {
          search: queryObject.search,
          filter: queryObject.filter,
          fields: queryObject.fields,
          include: queryObject.include,
          searchInclude: queryObject.searchInclude,
          filterInclude: queryObject.filterInclude,
          fieldsInclude: queryObject.fieldsInclude,
          filterOdds: queryObject.filterOdds,
          status: queryObject.status,
          order: queryObject.order,
          page: queryObject.page,
          limit: queryObject.limit,
        },
      });

      const payload = {
        data: response.data,
      }
      return payload;
    } catch (error) {
      console.error(error);
      return { error: 'Server error' };
    }
  };

  fetchLeaguesMatchesResultFull = async (queryObject) => {

    // Example param query: 
    // ?search=abc
    // &filter=type:1
    // &fields=id,matchTime,homeName,awayName,homeScore
    // &sort=name:asc
    // &page=1
    // &limit=10
    // &include=homeTeam,awayTeam
    // &searchInclude=abc
    // &filterInclude=date:2024-09-02
    // &fieldsInclude=id,matchTime,homeName,awayName,homeScore,awayScore,homeHalfScore,awayHalfScore,explain,status
    try {
      const response = await axios.get(`${baseUrl}/leagues`, {
        headers: {
          ['x-signature']: apiKey,
        },
        params: {
          search: queryObject.search,
          filter: queryObject.filter,
          fields: queryObject.fields,
          include: queryObject.include,
          searchInclude: queryObject.searchInclude,
          filterInclude: queryObject.filterInclude,
          fieldsInclude: queryObject.fieldsInclude,
          filterOdds: queryObject.filterOdds,
          status: queryObject.status,
          order: queryObject.order,
          page: queryObject.page,
          limit: queryObject.limit,
        },
      });

      const payload = {
        data: response.data,
      }
      return payload;
    } catch (error) {
      console.error(error);
      return { error: 'Server error' };
    }
  };

  fetchSearchItems = async (queryObject) => {
    // ?search=&fields=id,name&sort=name&page=1&limit=100000
    try {
      const response = await axios.get(`${baseUrl}/search`, {
        headers: {
          ['x-signature']: apiKey,
        },
        params: {
          type: queryObject.searchType,
          search: queryObject.search,
          fields: queryObject.fields,
          sort: queryObject.sort,
          page: queryObject.page,
          limit: queryObject.limit,
        },
      });
      const payload = {
        data: response.data,
      }
      return payload;
    } catch (error) {
      console.error(error);
      return { error: 'Server error' };
    }
  };

  fetchSearchTeams = async (queryObject) => {
    // ?search=&fields=id,name&sort=name&page=1&limit=100000
    try {
      const response = await axios.get(`${baseUrl}/teams`, {
        headers: {
          ['x-signature']: apiKey,
        },
        params: {
          search: queryObject.search,
          fields: queryObject.fields,
          sort: queryObject.sort,
          page: queryObject.page,
          limit: queryObject.limit,
        },
      });
      const payload = {
        data: response.data,
      }
      return payload;
    } catch (error) {
      console.error(error);
      return { error: 'Server error' };
    }
  };
  fetchSearchLeagues = async (queryObject) => {
    // ?search=&fields=id,name&sort=name&page=1&limit=100000
    try {
      const response = await axios.get(`${baseUrl}/leagues/league-in-bangkeo`, {
        headers: {
          ['x-signature']: apiKey,
        },
        params: {
          search: queryObject.search,
          fields: queryObject.fields,
          include: queryObject.include,
          sort: queryObject.sort,
          page: queryObject.page,
          limit: queryObject.limit,
        },
      });
      const payload = {
        data: response.data,
      }
      return payload;
    } catch (error) {
      console.error(error);
      return { error: 'Server error' };
    }
  };
  fetchSearchCountries = async (queryObject) => {
    // ?search=&fields=id,name&sort=name&page=1&limit=100000
    try {
      const response = await axios.get(`${baseUrl}/leagues/league-in-bangkeo`, {
        headers: {
          ['x-signature']: apiKey,
        },
        params: {
          search: queryObject.search,
          fields: queryObject.fields,
          sort: queryObject.sort,
          page: queryObject.page,
          limit: queryObject.limit,
        },
      });
      const payload = {
        data: response.data,
      }
      return payload;
    } catch (error) {
      console.error(error);
      return { error: 'Server error' };
    }
  };

  fetchMatchesByHomeAway = async (queryObject) => {
    try {
      const response = await axios.get(`${baseUrl}/matches`, {
        headers: {
          ['x-signature']: apiKey,
        },
        params: {
          filter: queryObject.filter,
          fields: queryObject.fields,
          include: queryObject.include,
          page: queryObject.page,
          limit: queryObject.limit,
        },
      });

      const payload = {
        data: response.data,
      }
      return payload;
    } catch (error) {
      console.error(error);
      return { error: error.message };
    }
  };
}


const instance = new BangkeoService();
export { instance as BangkeoService };